export async function fetchLastCaptureStatus(userEmail) {
    // Define the API endpoint with the user's email
    const apiUrl = `https://wacap.sausalitolab.com:3030/v0.1/users/${userEmail}/session?username=admin&password=brick-grape-megaton`;
 
    try {
        // Make the API request
        const response = await fetch(apiUrl);

        if (!response.ok) {
            // Handle non-successful response (e.g., HTTP error)
            throw new Error('Failed to fetch data');
        }
          
        const data = await response.json();
        // Extract the session from the API response
        const { status } = data;

        console.log("fetching last capture status from server: ", status);
        return status;
    } catch (error) {
        console.error('Error fetching session data:', error);
        return null;
    }
}

export function formatElapsedTime(epochTime) {
    const now = Date.now();
    const elapsedMilliseconds = now - epochTime;
  
    // Define time intervals in milliseconds
    const minute = 60 * 1000;
    const hour = 60 * minute;
    const day = 24 * hour;
  
    if (elapsedMilliseconds < minute) {
      const seconds = Math.floor(elapsedMilliseconds / 1000);
      return seconds === 1 ? '1 second ago' : `${seconds} seconds ago`;
    } else if (elapsedMilliseconds < hour) {
      const minutes = Math.floor(elapsedMilliseconds / minute);
      return minutes === 1 ? '1 minute ago' : `${minutes} minutes ago`;
    } else if (elapsedMilliseconds < day) {
      const hours = Math.floor(elapsedMilliseconds / hour);
      return hours === 1 ? '1 hour ago' : `${hours} hours ago`;
    } else {
      const days = Math.floor(elapsedMilliseconds / day);
      return days === 1 ? '1 day ago' : `${days} days ago`;
    }
}
